<template>
  <b-modal id="modal-kontainer" title="Tambah Kontainer" variant="success" ref="modalKontainer" hide-footer
    no-close-on-esc no-close-on-backdrop>
    <loading :active.sync="this.$store.state.barpin.isLoadingModal" :is-full-page="false"></loading>
    <!-- Fields -->
    <form @submit.prevent="addKontainer">
      <b-form-fieldset label="Nomor Kontainer">
        <b-form-input type="text" :class="errors.has('Nomor Kontainer') ? 'is-invalid' : ''"
          v-model="kontainer.no_kontainer" maxlength="11" name="Nomor Kontainer" v-validate="'required|min:11'"
          placeholder="Nomor Kontainer"></b-form-input>
        <div v-show="errors.has('Nomor Kontainer')" class="invalid-feedback">{{ errors.first('Nomor Kontainer') }}</div>
      </b-form-fieldset>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Ukuran Kontainer">
            <b-input-group right="Feet">
              <!-- <vue-numeric
                class="form-control"
                :class="errors.has('Ukuran Kontainer') ? 'is-invalid' : ''"
                v-model="kontainer.ukuran_kontainer"
                v-validate="'required'"
                name="Ukuran Kontainer"
                placeholder="20/40"
                maxlength="2"
              ></vue-numeric>-->
              <b-form-select v-validate="'required'" :class="errors.has('Ukuran Kontainer') ? 'is-invalid' : ''"
                :plain="true" name="Ukuran Kontainer" v-model="kontainer.ukuran_kontainer"
                :options="['20', '40', '45']"></b-form-select>
            </b-input-group>
          </b-form-fieldset>
          <div v-show="errors.has('Ukuran Kontainer')" class="invalid-feedback">{{ errors.first('Ukuran Kontainer') }}
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <b-form-fieldset label="Jenis Kontainer">
            <b-form-select v-validate="'required'" :class="errors.has('Jenis Kontainer') ? 'is-invalid' : ''"
              :plain="true" name="Jenis Kontainer" v-model="kontainer.jns_kontainer"
              :options="[{ text: 'FCL', value: 'F' }, { text: 'LCL', value: 'L' }]"></b-form-select>
            <div v-show="errors.has('Jenis Kontainer')" class="invalid-feedback">{{ errors.first('Jenis Kontainer') }}
            </div>
          </b-form-fieldset>
        </div>
      </div>
      <slot id="footer">
        <hr />
        <button type="submit" class="btn btn-success pull-right">
          <i class="fa fa-plus"></i> Tambah
        </button>
      </slot>
    </form>
  </b-modal>
</template>
<script>
import { mapActions } from 'vuex'
import swal from 'sweetalert'
export default {
  data () {
    return {
      kontainer: {
        no_kontainer: '',
        ukuran_kontainer: '',
        jns_kontainer: ''
      }
    }
  },
  methods: {
    ...mapActions({
      setKontainer: 'barpin/setKontainer'
    }),
    addKontainer () {
      // this.$validator.validateAll().then((result) => {
      //   if (result) console.log('berhasil')
      // })
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('barpin/SET_LOADING_MODAL', true)
          this.setKontainer({ ...this.kontainer, id_aju: this.$store.state.barpin.header.id_aju }).then(() => {
            this.$refs['modalKontainer'].hide()
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          }).catch((error) => {
            swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          })
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalKontainer.vue?4a80fc96